import { render, staticRenderFns } from "./AppBottomNavBar.vue?vue&type=template&id=0815b93c"
import script from "./AppBottomNavBar.vue?vue&type=script&lang=ts"
export * from "./AppBottomNavBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports